<template>
  <div class="animated fadeIn demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <Row>
          <Select
            size="small"
            style="width: 200px; margin-right: 5px;"
            v-model="selectGroupId"
            filterable
            clearable
            remote
            :remote-method="searchGroup"
            :loading="searchGroupLoading">
            <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}
            </Option>
          </Select>
          <Button size="small" type="primary" style="margin-right: 5px;" @click="onGroupFilterClick">查询</Button>
          <Button size="small" type="primary" style="margin-right: 5px;" @click="onClear">清空</Button>
          <Button size="small" type="primary" @click="onAddRootTransportVehicleInfoGroupClick">添加根分组</Button>
        </Row>
        <Row v-if="selectGroupId===null || selectGroupTree === null"
             :style="{height:(treeHeight + 'px'), overflow:'auto'}">
          <Col span="24">
            <Tree :data="defaultGroupData" :load-data="onLoadChildrenGroupData" style="overflow: hidden;"
                  :render="renderContent"></Tree>
          </Col>
        </Row>
        <Row v-if="selectGroupId!==null && selectGroupTree !== null"
             :style="{height:(treeHeight + 'px'), overflow:'auto'}">
          <Col span="24">
            <Tree :data="selectGroupTree" :load-data="onLoadChildrenGroupData" style="overflow: hidden;"
                  :render="renderContent"></Tree>
          </Col>
        </Row>
      </div>
      <div slot="right" class="demo-split-pane">
        <Row>
          <Input size="small" v-model="keywordFilter" placeholder="别名/安装地址" style="width: 200px; margin-right: 5px;" clearable @on-enter="onFilterClick"></Input>
          <Button size="small" type="primary" style="margin-right: 5px;" @click="onFilterClick">查询</Button>
        </Row>
        <Row style="margin-top: 5px;">
          <div style="width: 100%;">
            <div style="position:relative;">
              <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
              <Table border highlight-row size="small" height="600" :columns="columns" :data="content" ref="table"
                     :height="tableHeight"
                     @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
              <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
                <Spin size="large"></Spin>
                <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
              </div>
            </div>
            <Page :total="totalElements" :page-size="pageSize" :show-total="true" show-elevator @on-change="setPage"
                  style="text-align:right;margin-top:10px;"></Page>

          </div>
        </Row>
      </div>
    </Split>
    <add-transport-vehicle-info-group-modal v-model="addTransportVehicleInfoGroupModal"
                                    :initValue="addTransportVehicleInfoGroupParentId"></add-transport-vehicle-info-group-modal>
    <transport-vehicle-info-group-detail-modal v-model="transportVehicleInfoGroupDetailModal"
                                       :initValue="transportVehicleInfoGroupDetailId"></transport-vehicle-info-group-detail-modal>
    <vehicle-info-detail-modal v-model="transportVehicleInfoDetailModal" :initValue="transportVehicleInfoDetailId"
                                 @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <vehicle-picture-modal v-model="vehiclePictureModal" :initValue="vehiclePictureId"></vehicle-picture-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

import AddTransportVehicleInfoGroupModal from '@/view/transport/components/add-transport-vehicle-info-group-modal'
import TransportVehicleInfoGroupDetailModal from '@/view/transport/components/transport-vehicle-info-group-detail-modal'
import VehicleInfoDetailModal from '@/view/transport/components/vehicle-info-detail-modal'
import VehiclePictureModal from '@/view/transport/components/vehicle-picture-modal'

function calRegistrationTextColor (colorid) {
  if (colorid === 1) {
    return '#ffffff'
  } else if (colorid === 2) {
    return '#ffffff'
  } else if (colorid === 3) {
    return '#ffffff'
  } else if (colorid === 4) {
    return '#000000'
  } else {
    return '#000000'
  }
}
function calRegistrationColor (colorid) {
  if (colorid === 1) {
    return '#2b85e4'
  } else if (colorid === 2) {
    return '#ff9900'
  } else if (colorid === 3) {
    return '#1c2438'
  } else if (colorid === 4) {
    return '#f8f8f9'
  } else {
    return '#bbbec4'
  }
}

export default {
  // 此名称与routers.js中name一致方可缓存
  name: 'transportvehicleinfogroups',
  components: {
    AddTransportVehicleInfoGroupModal,
    TransportVehicleInfoGroupDetailModal,
    VehicleInfoDetailModal,
    VehiclePictureModal
  },
  data () {
    return {

      // 在线状态过滤
      runStatusFilter: [],
      ledlightSwFilter: [],

      deviceTypeFilter: null,

      treeHeight: 400,

      // 图片管理
      vehiclePictureModal: false,
      vehiclePictureId: null,

      // 增加分组
      addTransportVehicleInfoGroupModal: false,
      addTransportVehicleInfoGroupParentId: null,

      // 分组详细信息
      transportVehicleInfoGroupDetailModal: false,
      transportVehicleInfoGroupDetailId: null,

      // 当前选择设备
      currentSelectedDeviceId: null,
      currentSelectedDevice: null,
      currentSelectedRunStatus: null,

      refreshTimer: null,

      detailLoading: false,

      filterType: [],
      split1: 0.3,
      keywordFilter: null,
      isSearch: false,
      tempChildrenGroups: null,
      tempChildrenDevices: null,
      searchGroupLoading: false,
      searchGroupList: [],
      selectGroupId: null,
      selectTransportVehicleInfosByGroupId: null,
      selectTransportVehicleInfosByGroupName: null,
      selectGroupTree: null,
      defaultGroupData: [
        {
          id: 1,
          title: '无',
          expand: false,
          checked: true,
          selected: true,
          loading: false,
          children: []
        }
      ],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 添加运输车辆信息
      addTransportVehicleInfoModal: false,

      // 设置角色
      setRoleModal: false,
      setRoleTransportVehicleInfoId: null,

      // 运输车辆信息详细信息
      transportVehicleInfoDetailModal: false,
      transportVehicleInfoDetailId: null,

      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      pageSize: 0,
      content: [],
      totalElements: 0,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 80
        },
        {
          title: '车牌',
          resizable: true,
          key: 'registrationNum',
          ellipsis: 'true',
          width: 120,
          sortable: 'custom',
          render: function (h, params) {
            let registrationNum = params.row.registrationNum
            if (params.row.customName) {
              registrationNum = registrationNum + '(' + params.row.customName + ')'
            }
            return h('div', {
              props: {
                disabled: false
              },
              style: {
                'text-align': 'center',
                backgroundColor: calRegistrationColor(params.row.registrationColor),
                color: calRegistrationTextColor(params.row.registrationColor)
              },
              on: {
                click: () => {
                  // this.onRegistrationNOClick(params.row)
                }
              }
            }, registrationNum)
          }
        },
        {
          title: '违章数',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'peccancyRecordCount',
          width: 100
        },
        {
          title: '查询违章时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'queryPeccancyDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.queryPeccancyDatetime) {
              let d = new Date(params.row.queryPeccancyDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '车辆所有人',
          resizable: true,
          key: 'vehicleOwnerInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.vehicleOwnerInfoFilter = []
              val.forEach(item => {
                this.vehicleOwnerInfoFilter.push(genQueryParam('vehicleOwnerInfoId', 'EQ', item))
              })
            } else {
              this.vehicleOwnerInfoFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            if (params.row.vehicleOwnerInfo) {
              return h('label', params.row.vehicleOwnerInfo.shortName)
            }
          }
        },
        {
          title: '客户',
          resizable: true,
          key: 'clientInfoId',
          sortable: 'custom',
          ellipsis: 'true',
          minWidth: 180,
          render: (h, params) => {
            let display = []
            if (params.row.clientInfo) {
              display.push(h('div', params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '无'))
            }
            return h('div', display)
          }
        },
        {
          title: '车架号',
          resizable: true,
          key: 'vin',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '车辆类型',
          resizable: true,
          key: 'vehicleTypeId',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            if (params.row.vehicleType) {
              return h('label', params.row.vehicleType.name)
            }
          }
        },
        {
          title: '发动机号',
          resizable: true,
          key: 'engineNum',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '下次年审日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'yearCheckDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.yearCheckDatetime) {
              let d = new Date(params.row.yearCheckDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        // {
        //   title: '下次季审日期',
        //   resizable: true,
        //   sortable: 'custom',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   key: 'quarterCheckDatetime',
        //   width: 160,
        //   render: function (h, params) {
        //     if (params.row.quarterCheckDatetime) {
        //       let d = new Date(params.row.quarterCheckDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日'))
        //     }
        //   }
        // },
        {
          title: '交强险有效期日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'compulsoryInsuranceDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.compulsoryInsuranceDatetime) {
              let d = new Date(params.row.compulsoryInsuranceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '商业险有效期日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'commerceInsuranceDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.commerceInsuranceDatetime) {
              let d = new Date(params.row.commerceInsuranceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '挂靠费到费期日期',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'transportServiceDatetime',
          width: 160,
          render: function (h, params) {
            if (params.row.transportServiceDatetime) {
              let d = new Date(params.row.transportServiceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        // {
        //   title: '跟进业务员',
        //   resizable: true,
        //   key: 'businessUserId',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   width: 120,
        //   filters: [],
        //   filterMultiple: true,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       this.businessUserFilter = []
        //       val.forEach(item => {
        //         this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
        //       })
        //     } else {
        //       this.businessUserFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: function (h, params) {
        //     if (params.row.businessUser) {
        //       let name = null
        //       if (params.row.businessUser.realName) {
        //         name = params.row.businessUser.realName
        //       } else if (params.row.businessUser.nickName) {
        //         name = params.row.businessUser.nickName
        //       } else if (params.row.businessUser.name) {
        //         name = params.row.businessUser.name
        //       }
        //       return h('div', name)
        //     }
        //   }
        // },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 320,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.transportVehicleInfoDetailId = params.row.id
                    this.transportVehicleInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehiclePictureId = params.row.id
                    this.vehiclePictureModal = true
                  }
                }
              }, '图片管理'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    store.dispatch('PeccancyRecordServ_AnalyzeSingle', {
                      params: { transportVehicleInfoId: params.row.id },
                      urlparams: null
                    }).then(() => {
                      this.$Message.success('查询成功')
                    }).catch(err => {
                      this.$Message.error(err)
                    })
                  }
                }
              }, '查询违章')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small',
              //     disabled: false
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.changeBusinessUserTransportVehicleInfoId = params.row.id
              //       this.changeBusinessUserModal = true
              //     }
              //   }
              // }, '指定业务跟进')
            ])
          }
        }
      ]// cloumn
    }
  },
  methods: {
    ...mapActions([
      'TransportVehicleInfoGroupServ_GetRootTransportVehicleInfoGroups',
      'TransportVehicleInfoGroupServ_GetChildrenTransportVehicleInfoGroups',
      'TransportVehicleInfoGroupServ_SearchByName',
      'TransportVehicleInfoGroupServ_GetDetail',
      'UserServ_GetPage',
      'UserServ_ResetPassword',
      'UserServ_Disable'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, -650, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onClear () {
      this.selectGroupId = null
      this.selectGroupTree = null
    },
    onAddRootTransportVehicleInfoGroupClick () {
      this.addTransportVehicleInfoGroupParentId = null
      this.addTransportVehicleInfoGroupModal = true
    },
    onFilterTypeChange () {
      this.refreshPage()
    },
    searchGroup (input) {
      this.searchGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchGroupList = []
        this.searchGroupLoading = false
      } else {
        store.dispatch('TransportVehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchGroupList = store.getters.get_TransportVehicleInfoGroup_SearchByNameResult ? store.getters.get_TransportVehicleInfoGroup_SearchByNameResult : []
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      }
    },
    onGroupFilterClick () {
      if (this.selectGroupId !== null) {
        store.dispatch('TransportVehicleInfoGroupServ_GetDetail', {
          params: { id: this.selectGroupId },
          urlparams: null
        }).then(() => {
          let result = store.getters.get_TransportVehicleInfoGroup_GetDetailResult ? store.getters.get_TransportVehicleInfoGroup_GetDetailResult : []
          this.selectGroupTree = [{
            id: result.id,
            title: result.name,
            nodeType: 'TransportVehicleInfoGroup',
            expand: false,
            loading: false,
            children: []
          }]
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
        console.log('this.selectGroupId !== null')
      } else {
        this.refreshRootTransportVehicleInfoGroups()
      }
    },
    onFilterClick () {
      this.setPage(1)
    },
    onLiftInfoModifySuccess () {
      this.refreshDetail()
    },
    onLoadChildrenGroupData (item, callback) {
      // 加载子区域
      store.dispatch('TransportVehicleInfoGroupServ_GetChildrenGroups', {
        params: { id: item.id },
        urlparams: null
      }).then(() => {
        let tempData = []
        this.tempChildrenGroups = store.getters.get_TransportVehicleInfoGroup_GetChildrenGroupsResult ? store.getters.get_TransportVehicleInfoGroup_GetChildrenGroupsResult : []

        this.tempChildrenGroups.forEach((dtoitem, index) => {
          tempData.push({
            id: dtoitem.id,
            title: dtoitem.name,
            nodeType: 'TransportVehicleInfoGroup',
            expand: false,
            loading: false,
            children: [],
            parent: item
          })
        })
        callback(tempData)

        // 加载子设备
        // store.dispatch('TransportVehicleInfoGroupServ_GetChildrenDevices', {
        //   params: { id: item.id },
        //   urlparams: null
        // }).then(() => {
        //   this.tempChildrenDevices = store.getters.get_TransportVehicleInfoGroup_GetChildrenDevicesResult ? store.getters.get_TransportVehicleInfoGroup_GetChildrenDevicesResult : []
        //
        //   this.tempChildrenGroups.forEach((dtoitem, index) => {
        //     tempData.push({
        //       id: dtoitem.id,
        //       title: dtoitem.name,
        //       nodeType: 'TransportVehicleInfoGroup',
        //       expand: false,
        //       loading: false,
        //       children: [],
        //       parent: item
        //     })
        //   })
        //
        //   this.tempChildrenDevices.forEach((dtoitem, index) => {
        //     tempData.push({
        //       id: dtoitem.id,
        //       title: dtoitem.nickName,
        //       nodeType: 'Device',
        //       classType: dtoitem.classType,
        //       expand: true,
        //       // loading: false,
        //       // children: [],
        //       parent: item
        //     })
        //   })
        //   callback(tempData)
        // }).catch(err => {
        //   this.$Message.error(err)
        //   callback(tempData)
        // })
      }).catch(err => {
        this.$Message.error(err)
        callback(tempData)
      })
    },
    renderContent (h, { root, node, data }) {
      let funcKeys = []
      if (data.nodeType == 'Device') {
        // funcKeys.push(
        //   h('Button', {
        //     props: {
        //       size: 'small'
        //     },
        //     style: {
        //       marginRight: '3px'
        //     },
        //     on: {
        //       click: () => {
        //         if (data.classType == 1) {
        //           this.liftInfoDetailId = data.id
        //           this.liftInfoDetailModal = true
        //         }
        //       }
        //     }
        //   }, '#')
        // )
      } else if (data.nodeType == 'TransportVehicleInfoGroup') {
        funcKeys.push(
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '3px'
            },
            on: {
              click: () => {
                console.log(data.id)
                this.addTransportVehicleInfoGroupParentId = data.id
                this.addTransportVehicleInfoGroupModal = true
              }
            }
          }, '+'),
          h('Button', {
            props: {
              size: 'small'
            },
            style: {
              marginRight: '3px'
            },
            on: {
              click: () => {
                this.transportVehicleInfoGroupDetailId = data.id
                this.transportVehicleInfoGroupDetailModal = true
              }
            }
          }, '#')
        )
      }

      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              type: data.nodeType == 'Device' ? 'ios-paper-outline' : 'ios-folder-outline'
            },
            style: {
              marginRight: '8px'
            }
          }),
          h('span', {
            style: {
              // fontSize:'medium',
              // backgroundColor:'#2db7f5',
              // color:'#ffffff'
            },
            on: {
              click: () => {
                this.selectTransportVehicleInfosByGroupName = data.title
                this.selectTransportVehicleInfosByGroupId = data.id
                this.setPage(1)
              }
            }
          }, data.title)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '5px',
            position: 'absolute',
            right: '0px'
          }
        }, funcKeys)
      ])
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    filterChange () {
      this.setPage(1)
    },
    onSuccess () {

    },
    refreshDetail () {
      if (this.currentSelectedDeviceId) {
        this.detailLoading = true
        this.currentSelectedDevice = null
        store.dispatch('TransportVehicleInfoGroupServ_GetDeviceDetail', {
          params: { baseDeviceId: this.currentSelectedDeviceId },
          urlparams: null
        }).then(() => {
          this.currentSelectedDevice = store.getters.get_TransportVehicleInfoGroup_GetDeviceDetailResult ? store.getters.get_TransportVehicleInfoGroup_GetDeviceDetailResult : null
          this.detailLoading = false
        }).catch(err => {
          this.detailLoading = false
        })
      }
    },
    onGroupOPSuccess () {
      this.refreshRootTransportVehicleInfoGroups()
    },
    refreshRootTransportVehicleInfoGroups () {
      console.log('refreshRootTransportVehicleInfoGroups')
      store.dispatch('TransportVehicleInfoGroupServ_GetRootTransportVehicleInfoGroups', {
        params: null,
        urlparams: null
      }).then(() => {
        let tempData = []
        let result = store.getters.get_TransportVehicleInfoGroup_GetRootTransportVehicleInfoGroupsResult ? store.getters.get_TransportVehicleInfoGroup_GetRootTransportVehicleInfoGroupsResult : []
        result.forEach((dtoitem, index) => {
          tempData.push({
            id: dtoitem.id,
            title: dtoitem.name,
            nodeType: 'TransportVehicleInfoGroup',
            expand: false,
            loading: false,
            children: [],
            parent: null
          })
        })
        this.defaultGroupData = tempData
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    setPage (page) {
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let sortParam = null
      let qo1 = null

      if (this.selectTransportVehicleInfosByGroupId) {
        queryParams.push(genQueryParam('transportVehicleInfoGroupId', 'EQ', this.selectTransportVehicleInfosByGroupId))
      } else {
        queryParams.push(genQueryParam('transportVehicleInfoGroupId', 'EQNULL', null))
      }

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.deviceTypeFilter) {
        qo1 = this.deviceTypeFilter
      }

      store.dispatch('TransportVehicleInfoServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        if (store.getters.get_TransportVehicleInfo_GetPageResult) {
          this.totalElements = store.getters.get_TransportVehicleInfo_GetPageResult.totalElements
          this.content = store.getters.get_TransportVehicleInfo_GetPageResult.content
          this.pageSize = store.getters.get_TransportVehicleInfo_GetPageResult.size
        } else {
          this.totalElements = 0
          this.content = []
          this.pageSize = 0
        }
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage () {
      this.setPage(this.pageIndex)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage()
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      this.refreshRootTransportVehicleInfoGroups()
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 170

      store.dispatch('TransportVehicleInfoGroupServ_ClientGetMyTransportVehicleInfoGroupOverview', {
        params: null,
        urlparams: null
      }).then(() => {

      }).catch(err => {
        this.$Message.error(err)
      })
    })
  }
}
</script>
<style>
  .demo-split {
    height: 100%;
    border: 1px solid #dcdee2;
  }

  .demo-split-pane {
    padding: 10px;
  }
</style>
